"use client";

import LogoBox from "@/components/LogoBox";
import IconifyIcon from "@/components/wrappers/IconifyIcon";
import SimplebarReactClient from "@/components/wrappers/SimplebarReactClient";
import React, { Suspense, useEffect, useState } from "react";
import AppMenu from "./components/AppMenu";
import FallbackLoading from "@/components/FallbackLoading";
import { getMenuItems } from "@/helpers/Manu";
import Image from "next/image";
import avatar1 from "@/assets/images/users/avatar-1.jpg";
import { Dropdown, DropdownHeader, DropdownItem, DropdownMenu, DropdownToggle } from "react-bootstrap";
import { useLayoutContext } from "@/context/useLayoutContext";
import HoverMenuToggle from "./components/HoverMenuToggle";

import { fetchWrapper } from "@/helpers/fetch-wrapper"; 

const LeftSideBar = () => {
	const menuItems = getMenuItems();
	const { mainMenu, changeMainMenuSize } = useLayoutContext();
	const changeMenu = () => {
		if (mainMenu.size == "default") {
			changeMainMenuSize("condensed");
		} else if (mainMenu.size == "full") {
			changeMainMenuSize("default");
		}
	};

     const [userData, setUserData] = useState([]); 

     useEffect(() => {
          const fetchUserData = async () => {
               try {
                    const response = await fetchWrapper.get('/api/users/getdata');

                    setUserData(response[0].userData); 
       
               } catch (error) {
                    console.error('An error occurred while fetching user data:', error);
               }
          };

          fetchUserData();
     }, []);

	return (
		<div className='sidenav-menu'>
			<LogoBox />
			<HoverMenuToggle />
			{/* <button  className="button-sm-hover">
        <IconifyIcon icon='ri:circle-line' className="align-middle" />
       </button>
       <button onClick={() => changeMainMenuSize('sm-hover')} className="button-sm-hover">
        <IconifyIcon icon='ri:circle-line' className="align-middle" />
       </button> */}
			<button onClick={changeMenu} className='sidenav-toggle-button'>
				<IconifyIcon icon='ri:menu-5-line' className='fs-20' />
			</button>
			{/* <button className="button-close-fullsidebar">
        <IconifyIcon icon='ti:x' className="align-middle" />
       </button> */}

			<SimplebarReactClient data-simplebar>
				<div className='sidenav-user'>
					<Dropdown className='dropdown-center text-center'>
						<DropdownToggle
							as={"a"}
							className='topbar-link text-reset drop-arrow-none px-2'
							data-bs-toggle='dropdown'
							type='button'
							aria-haspopup='false'
							aria-expanded='false'>
							<Image src={userData?.avatar ? userData?.avatar : avatar1} width={46} height={46} className='rounded-circle' alt='user-image' />
							<span className='d-flex gap-1 sidenav-user-name my-2'>
								<span>
									<span className='mb-0 fw-semibold lh-base fs-15'>{userData?.name}</span>
								</span>
				
							</span>
						</DropdownToggle>
						
					</Dropdown>
				</div>

				<Suspense fallback={<FallbackLoading />}>
					<AppMenu menuItems={menuItems} />
				</Suspense>

	
				<div className='clearfix' />
			</SimplebarReactClient>
		</div>
	);
};
export default LeftSideBar;
